import { useOrgContext } from '@/org/contexts/OrgContext'
import { useMemo } from 'react'
import { MemberProposal, proposeMember } from '../proposedMember'

interface Result {
  proposal: MemberProposal
  // Everyone holding the role, to know whether a default member belongs (#149).
  holderIds: string[]
}

// The member to propose for a role, from the org's current holders (#123).
export default function useMemberProposal(
  circleId: string | undefined
): Result | undefined {
  const { orgData } = useOrgContext()
  return useMemo(() => {
    if (!circleId || !orgData) return undefined
    const holders = orgData
      .membersOf(circleId)
      .map(({ member }) => ({ id: member.id, name: member.name }))
    return {
      proposal: proposeMember(holders),
      holderIds: holders.map((holder) => holder.id),
    }
  }, [orgData, circleId])
}
